import axios from 'axios';
import { useState } from 'react';

import { POST_CLAIMS_SEARCH } from '../constants/api';

export const useClaims = () => {
  const [results, setResults] = useState(null);
  const [loadingSearchResults, setLoadingSearchResults] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState();

  const getAutocompleteEndpoint = (searchByType) => {
    switch (searchByType) {
      case 'policyNumber':
        return 'policy-number';
      case 'insuredName':
        return 'insured-last-name';
      case 'claimantName':
        return 'claimant-last-name';
      case 'openClaims':
        return 'open-claims';
    }
  };

  const getSearchByType = (searchByType, claimantNameSearchType) => {
    switch (searchByType) {
      case 'policyNumber':
      case 'insuredName':
      case 'openClaims':
        return 'exact';
      case 'claimantName':
        return claimantNameSearchType;
    }
  };

  const fetchResults = async (searchByType, claimantNameSearchType, searchText, pageNumber = 1) => {
    try {
      setLoadingSearchResults(true);
      const searchUrl = `${POST_CLAIMS_SEARCH}/${getSearchByType(searchByType, claimantNameSearchType)}/${getAutocompleteEndpoint(searchByType)}/${pageNumber}`;
      const results = await axios.post(searchUrl, searchText);
      setResults(results.data);
    } catch (error) {
      if (error?.response?.status === 403) {
        setError('Forbidden - Missing necessary permissions, please contact customer service.');
      }else{
        setError('There was a problem processing this request. We are sorry for the inconvenience. Please contact the Help Desk or try again later.');
      }
      console.error('Claims: ', error);
    } finally {
      setLoadingSearchResults(false);
    }
  };

  const handleClickPaginationChange = (page, searchByType, claimantNameSearchType, searchText) => {
    fetchResults(searchByType, claimantNameSearchType, searchText, page + 1);
  };

  const handleSearchOnClick = async (searchByType, claimantNameSearchType, searchText) => {
    resetState();
    await fetchResults(searchByType, claimantNameSearchType, searchText);
  };

  const resetState = () => {
    setResults(null);
    setPageNumber(1);
    setError();
  };

  return {
    error,
    loadingSearchResults,
    pageNumber,
    results,
    getAutocompleteEndpoint,
    handleClickPaginationChange,
    handleSearchOnClick,
    resetState,
  };
};
